import AppState from '../AppState';
import { OptionServiceType } from '../models/enums';
// Create radio SVGs for plan header.
export const planSvgChecked = `
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
    <path d="M12.0716 3.5L5.65495 9.91667L2.73828 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;
export const planSvgUnchecked = `
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.90625" y="0.5" width="19" height="19" rx="9.5" fill="#F9FAFB"/>
    <rect x="0.90625" y="0.5" width="19" height="19" rx="9.5" stroke="#EAECF0"/>
  </svg>
`;
export const standardSpeed = `
  <svg xmlns="http://www.w3.org/2000/svg" width="116" height="65" viewBox="0 0 116 65" fill="none">
    <mask id="mask0_5590_17484" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="116" height="64">
      <rect width="116" height="64" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_5590_17484)">
      <path d="M108 58C108 51.3026 106.681 44.6707 104.118 38.4831C101.555 32.2955 97.7982 26.6733 93.0624 21.9376C88.3267 17.2018 82.7045 13.4451 76.5169 10.8821C70.3292 8.31915 63.6974 7 57 7C50.3026 7 43.6708 8.31915 37.4832 10.8821C31.2956 13.4451 25.6734 17.2017 20.9376 21.9375C16.2018 26.6733 12.4451 32.2955 9.88215 38.4831C7.31916 44.6707 6 51.3025 6 58" stroke="#0030DC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 58C6 47.9131 8.9911 38.0528 14.5951 29.6659C20.199 21.279 28.1641 14.7422 37.4832 10.8821C46.8022 7.02207 57.0566 6.0121 66.9496 7.97995C76.8427 9.9478 85.93 14.8051 93.0625 21.9376" stroke="#0037FC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 58C6 44.474 11.3732 31.5019 20.9376 21.9376C30.5019 12.3732 43.474 7 57 7" stroke="#7D98F9" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 58C6 51.3026 7.31916 44.6707 9.88215 38.4831C12.4451 32.2955 16.2018 26.6733 20.9376 21.9375" stroke="#BECBFC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M18.5058 38.6086L59.3616 58.9969L56.5905 63.7967L18.5058 38.6086Z" fill="#272525"/>
    <path d="M58.6125 58.2867C60.0529 59.1183 60.5465 60.9602 59.7148 62.4007C58.8832 63.8411 57.0413 64.3346 55.6008 63.503C54.1604 62.6714 53.6669 60.8295 54.4985 59.389C55.3301 57.9486 57.172 57.455 58.6125 58.2867Z" fill="#272525"/>
  </svg>
`;
export const standardPlusSpeed = `
  <svg xmlns="http://www.w3.org/2000/svg" width="116" height="64" viewBox="0 0 116 64" fill="none">
    <mask id="mask0_3776_24106" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="116" height="64">
      <rect width="116" height="64" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_3776_24106)">
      <path d="M108 58C108 51.3026 106.681 44.6707 104.118 38.4831C101.555 32.2955 97.7982 26.6733 93.0624 21.9376C88.3267 17.2018 82.7045 13.4451 76.5169 10.8821C70.3292 8.31915 63.6974 7 57 7C50.3026 7 43.6708 8.31915 37.4832 10.8821C31.2956 13.4451 25.6734 17.2017 20.9376 21.9375C16.2018 26.6733 12.4451 32.2955 9.88215 38.4831C7.31916 44.6707 6 51.3025 6 58" stroke="#22296C" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 58C6 46.7722 9.70511 35.8583 16.5406 26.951C23.3761 18.0438 32.9599 11.6412 43.8054 8.7364C54.6509 5.83158 66.1518 6.5869 76.5243 10.8852C86.8967 15.1835 95.5608 22.7846 101.173 32.5093" stroke="#232968" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 58C6 47.9131 8.9911 38.0528 14.5951 29.6659C20.199 21.279 28.1641 14.7422 37.4832 10.8821C46.8022 7.02207 57.0566 6.0121 66.9496 7.97995C76.8427 9.9478 85.93 14.8051 93.0625 21.9376" stroke="#0037FC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 58C6 44.474 11.3732 31.5019 20.9376 21.9376C30.5019 12.3732 43.474 7 57 7" stroke="#7D98F9" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 58C6 51.3026 7.31916 44.6707 9.88215 38.4831C12.4451 32.2955 16.2018 26.6733 20.9376 21.9375" stroke="#BECBFC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M27.1296 28.1302L61.3164 58.398L57.3973 62.317L27.1296 28.1302Z" fill="#272525"/>
    <path d="M60.7766 57.5181C61.9527 58.6942 61.9527 60.6011 60.7766 61.7772C59.6004 62.9533 57.6936 62.9533 56.5174 61.7772C55.3413 60.6011 55.3413 58.6942 56.5174 57.5181C57.6936 56.342 59.6004 56.342 60.7766 57.5181Z" fill="#272525"/>
  </svg>
`;
export const premiumSpeed = `
  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="54" viewBox="0 0 96 54" fill="none">
    <mask id="mask0_2449_46214" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="96" height="54">
      <rect width="96" height="54" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2449_46214)">
      <path d="M88.7177 47.1079C88.7177 41.6682 87.6463 36.2818 85.5646 31.2562C83.483 26.2306 80.4318 21.6643 76.5854 17.8179C72.739 13.9714 68.1726 10.9203 63.147 8.83863C58.1214 6.75697 52.735 5.68555 47.2954 5.68555C41.8557 5.68554 36.4694 6.75696 31.4438 8.83862C26.4182 10.9203 21.8518 13.9714 18.0054 17.8178C14.159 21.6643 11.1078 26.2306 9.02614 31.2562C6.94447 36.2818 5.87305 41.6682 5.87305 47.1078" stroke="#0030DC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 38.9153 8.30243 30.9067 12.854 24.0949C17.4055 17.283 23.8748 11.9738 31.4437 8.83863C39.0127 5.70347 47.3413 4.88318 55.3765 6.48147C63.4116 8.07976 70.7924 12.0249 76.5854 17.8179" stroke="#0037FC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 36.122 10.2372 25.5861 18.0054 17.8179C25.7736 10.0497 36.3095 5.68555 47.2954 5.68555" stroke="#7D98F9" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 41.6682 6.94447 36.2818 9.02614 31.2562C11.1078 26.2306 14.159 21.6643 18.0054 17.8179" stroke="#BECBFC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M50.4461 15.002L52.6968 52.0191H48.1953L50.4461 15.002Z" fill="#333333"/>
    <path d="M52.8921 51.2038C52.8921 52.5547 51.797 53.6498 50.4461 53.6498C49.0951 53.6498 48 52.5547 48 51.2038C48 49.8528 49.0951 48.7577 50.4461 48.7577C51.797 48.7577 52.8921 49.8528 52.8921 51.2038Z" fill="#333333"/>
  </svg>
`;
export const superFastSpeed = `
  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="54" viewBox="0 0 96 54" fill="none">
    <mask id="mask0_2449_46244" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="96" height="54">
      <rect width="96" height="54" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2449_46244)">
      <path d="M88.7177 47.1079C88.7177 41.6682 87.6463 36.2818 85.5646 31.2562C83.483 26.2306 80.4318 21.6643 76.5854 17.8179C72.739 13.9714 68.1726 10.9203 63.147 8.83863C58.1214 6.75697 52.735 5.68555 47.2954 5.68555C41.8557 5.68554 36.4694 6.75696 31.4438 8.83862C26.4182 10.9203 21.8518 13.9714 18.0054 17.8178C14.159 21.6643 11.1078 26.2306 9.02614 31.2562C6.94447 36.2818 5.87305 41.6682 5.87305 47.1078" stroke="#0030DC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 38.9153 8.30243 30.9067 12.854 24.0949C17.4055 17.283 23.8748 11.9738 31.4437 8.83863C39.0127 5.70347 47.3413 4.88318 55.3765 6.48147C63.4116 8.07976 70.7924 12.0249 76.5854 17.8179" stroke="#0037FC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 36.122 10.2372 25.5861 18.0054 17.8179C25.7736 10.0497 36.3095 5.68555 47.2954 5.68555" stroke="#7D98F9" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 41.6682 6.94447 36.2818 9.02614 31.2562C11.1078 26.2306 14.159 21.6643 18.0054 17.8179" stroke="#BECBFC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M74.0592 24.7277L49.4756 52.4943L46.2926 49.3112L74.0592 24.7277Z" fill="#333333"/>
    <path d="M50.1903 52.0559C49.2351 53.0111 47.6863 53.0111 46.731 52.0559C45.7758 51.1006 45.7758 49.5518 46.731 48.5966C47.6863 47.6413 49.2351 47.6413 50.1903 48.5966C51.1456 49.5518 51.1456 51.1006 50.1903 52.0559Z" fill="#333333"/>
  </svg>
`;
export const ultraFastSpeed = `
  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="54" viewBox="0 0 96 54" fill="none">
    <mask id="mask0_2449_46274" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="96" height="54">
      <rect width="96" height="54" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2449_46274)">
      <path d="M88.7177 47.1079C88.7177 41.6682 87.6463 36.2818 85.5646 31.2562C83.483 26.2306 80.4318 21.6643 76.5854 17.8179C72.739 13.9714 68.1726 10.9203 63.147 8.83863C58.1214 6.75697 52.735 5.68555 47.2954 5.68555C41.8557 5.68554 36.4694 6.75696 31.4438 8.83862C26.4182 10.9203 21.8518 13.9714 18.0054 17.8178C14.159 21.6643 11.1078 26.2306 9.02614 31.2562C6.94447 36.2818 5.87305 41.6682 5.87305 47.1078" stroke="#0030DC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 38.9153 8.30243 30.9067 12.854 24.0949C17.4055 17.283 23.8748 11.9738 31.4437 8.83863C39.0127 5.70347 47.3413 4.88318 55.3765 6.48147C63.4116 8.07976 70.7924 12.0249 76.5854 17.8179" stroke="#0037FC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 36.122 10.2372 25.5861 18.0054 17.8179C25.7736 10.0497 36.3095 5.68555 47.2954 5.68555" stroke="#7D98F9" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.87305 47.1079C5.87305 41.6682 6.94447 36.2818 9.02614 31.2562C11.1078 26.2306 14.159 21.6643 18.0054 17.8179" stroke="#BECBFC" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M83.6479 51.4461L46.6308 53.6968L46.6308 49.1953L83.6479 51.4461Z" fill="#333333"/>
    <path d="M47.4461 53.8921C46.0952 53.8921 45.0001 52.797 45.0001 51.4461C45.0001 50.0951 46.0952 49 47.4461 49C48.7971 49 49.8922 50.0951 49.8922 51.4461C49.8922 52.797 48.7971 53.8921 47.4461 53.8921Z" fill="#333333"/>
  </svg>
`;
/**
 * Toggles the selected state of a plan element and updates the SVG icon
 * based on whether it is checked or unchecked.
 *
 * @param {HTMLElement} plan - The plan element to be toggled.
 * @param {string} planSvgChecked - The SVG icon for checked state.
 * @param {string} planSvgUnchecked - The SVG icon for unchecked state.
 */
export const togglePlans = (plan, planSvgChecked, planSvgUnchecked) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { context } = drupalJsObjects;
    const siblingPlans = context.querySelectorAll('.service-plans--service-plan:not(.disabled)');
    siblingPlans.forEach((siblingPlan) => {
        siblingPlan.classList.remove('selected');
        siblingPlan.querySelector('.plan-radio').innerHTML = planSvgUnchecked;
    });
    plan.classList.add('selected');
    plan.querySelector('.plan-radio').innerHTML = planSvgChecked;
};
/**
 * Removes the specified prefix from the given input string.
 *
 * @param {string} inputString - The input string from which the prefix should
 *                               be removed.
 * @param {string} prefixToRemove - The prefix to remove from the input string.
 * @returns {string} - The input string without the prefix, if it starts with
 *                     the specified prefix; otherwise, the input string itself.
 */
export const removePrefix = (inputString, prefixToRemove) => {
    if (inputString.startsWith(prefixToRemove)) {
        return inputString.substring(prefixToRemove.length);
    }
    return inputString;
};
/**
 * Modify plan based on the availability of T1Tact offer promo
 *
 * @param {AvailableSelections} plan - The plan object to be modified
 */
export const addT1TactOfferPromo = (plan) => {
    const sfpModel = AppState.get('serviceFunnelPackage');
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const mutableOptions = AppState.get('mutableOptions');
    const { context } = drupalJsObjects;
    const superfastElement = context.querySelector('[data-plan-identifier="SBCHRG9"]');
    const ultrafastElement = context.querySelector('[data-plan-identifier="SBCHRG11"]');
    if (sfpModel.isCoat) {
        const upgrade250 = mutableOptions.find((option) => option.OptionType === 23 && option.PlanIdentifier === 'SBCHRG9');
        const upgrade1000 = mutableOptions.find((option) => option.OptionType === 23 && option.PlanIdentifier === 'SBCHRG11');
        if (upgrade250) {
            if (superfastElement) {
                superfastElement.setAttribute('data-plan-identifier', upgrade250.PlanIdentifier);
            }
            plan.showSpeedUpgrade = false;
            plan.showFibreUpgrade = true;
        }
        if (upgrade1000) {
            if (ultrafastElement) {
                ultrafastElement.setAttribute('data-plan-identifier', upgrade1000.PlanIdentifier);
            }
            plan.showSpeedUpgrade = false;
            plan.showFibreUpgrade = true;
        }
    }
};
/**
 * Rotates messages in a container element.
 *
 * @function messageRotator
 */
export const messageRotator = () => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal, context } = drupalJsObjects;
    const messageRotatorContainer = context.querySelector('#rotating-text');
    const addressCheckMessages = [
        Drupal.t('Looking up your address... just a moment, please!'),
        Drupal.t('Scanning your address for service availability. Stay patient!'),
        Drupal.t('Double-checking availability at your location. Stay tuned!'),
        Drupal.t('Confirming your address... just a few seconds more!'),
        Drupal.t('Verifying address details... almost there!'),
    ];
    messageRotatorContainer.style.display = 'block';
    addressCheckMessages.forEach((message, i) => {
        setTimeout(() => {
            messageRotatorContainer.innerText = message;
        }, 3000 * i);
    });
};
/**
 * Fills the suffix field of an address with characters from another field.
 *
 * @param {Address} addressInput - The address object to modify.
 * @param {keyof Address} suffixFieldName - The name of the suffix field to fill.
 * @param {keyof Address} fieldWithSuffixName - The name of the field containing
 *                                              characters to fill the suffix field.
 */
export const fillSuffixFields = (addressInput, suffixFieldName, fieldWithSuffixName) => {
    const regExp = /[a-zA-Z]/g;
    const string = addressInput[fieldWithSuffixName];
    for (let character of string) {
        if (regExp.test(character)) {
            addressInput[suffixFieldName] = character;
            addressInput[fieldWithSuffixName] = addressInput[fieldWithSuffixName].replace(character, '');
        }
    }
    if (!addressInput.hasOwnProperty(suffixFieldName)) {
        addressInput[suffixFieldName] = '';
    }
};
/**
 * Builds a composite address string from the given Address object.
 *
 * @param {Address} address - The Address object containing the address information.
 * @return {string} - The composite address string.
 */
export const buildCompositeAddress = (address) => {
    var _a, _b;
    const addressList = [
        address.UnitTypeCode,
        address.UnitNumber + address.UnitSuffix,
        address.LevelTypeCode,
        address.LevelNumber + address.LevelNumberSuffix,
        address.StreetNumber + address.StreetNumber1Suffix,
        address.StreetNumber2,
        (_a = address.StreetName) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
        address.StreetType + address.StreetSuffixCode,
        (_b = address.Suburb) === null || _b === void 0 ? void 0 : _b.toUpperCase(),
        address.StateName,
        address.Postcode,
    ];
    return addressList.filter(addressItem => Boolean(addressItem)).join(' ');
};
/**
 * Use to get the Service Type name from OptionServiceType.
 *
 * @param {number} value - The value to search for in the object.
 * @returns {string | undefined} - The key whose value matches the given value,
 *                                 or undefined if no match is found.
 */
export const getKeyByValue = (value) => {
    return Object.keys(OptionServiceType)
        .filter(key => typeof OptionServiceType[key] === "number")
        .find(key => OptionServiceType[key] === value);
};
/**
 * Toggles the display of available plans.
 *
 * @param {HTMLElement} serviceAvailable - The element containing the available
 *                                         service plans.
 */
export const planDisplayToggle = (serviceAvailable) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal, context } = drupalJsObjects;
    const serviceUpgrades = context.querySelector('#service-upgrades');
    let serviceUpgradesShow = false;
    serviceUpgrades.style.display = 'none';
    const seeAllLink = document.createElement('p');
    seeAllLink.classList.add('see-all-plans');
    seeAllLink.innerHTML = `<a id="available-plans-link">${Drupal.t('See all available plans')}</a>`;
    serviceAvailable.parentElement.appendChild(seeAllLink);
    seeAllLink.querySelector('#available-plans-link').onclick = event => {
        if (!serviceUpgradesShow) {
            serviceUpgradesShow = true;
            serviceUpgrades.style.display = 'block';
            event.target.innerText = 'Hide all available plans';
        }
        else {
            serviceUpgradesShow = false;
            serviceUpgrades.style.display = 'none';
            event.target.innerText = 'See all available plans';
        }
    };
};
/**
 * Calculates the base price for a given plan.
 *
 * @param {AvailableSelections} plan - The selected plan
 * @returns {number} - The calculated base price
 */
export const calculateBasePrice = (plan) => {
    var _a, _b;
    if (plan.PlanGroupID === 162) {
        const unlimitedInclusion = plan.IncludedOptions.find(option => option.PlanIdentifier === 'DBCHRG3');
        if (unlimitedInclusion) {
            return ((_a = plan === null || plan === void 0 ? void 0 : plan.MonthlyFee) !== null && _a !== void 0 ? _a : 0) + ((_b = unlimitedInclusion === null || unlimitedInclusion === void 0 ? void 0 : unlimitedInclusion.OptionFee) !== null && _b !== void 0 ? _b : 0);
        }
    }
    return 0;
};
/**
 * Returns the mapped access type.
 *
 * @param {string} acessType - The access type.
 * @returns {string} - The mapped value.
 */
export const getMappedAccessType = (acessType) => {
    switch (acessType) {
        case 'Fibre':
            return 'Fibre to the Premises (FTTP)';
        case 'Wireless':
            return 'Fixed Wireless (FW)';
        case 'HFC':
            return 'Hybrid Fibre Coaxial (HFC)';
        case 'Fibre To The Curb':
            return 'Fibre to the Curb (FTTC)';
        case 'Fibre To The Building':
            return 'Fibre to the Building (FTTB)';
        case 'Fibre To The Node':
            return 'Fibre to the Node (FTTN)';
        default:
            return undefined;
    }
};
